import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import ChatComponent from '../components/ChatComponent';
import { CHAT_CHA } from '../theme/chatChaavi';

const ClientChat: React.FC = () => {
  const { user } = useAuth();

  if (!user) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
        <Typography variant="h6">Please log in to access chat</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        bgcolor: CHAT_CHA.pageBg,
        minHeight: { xs: 'calc(100dvh - 56px)', sm: 'calc(100dvh - 64px)' },
        height: { xs: 'calc(100dvh - 56px)', sm: 'calc(100dvh - 64px)' },
        pt: { xs: 1.25, md: 1.5 },
        pb: { xs: 2, md: 2 },
        px: { xs: 2, sm: 3, md: 4 },
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
      }}
    >
      <Typography
        variant="h4"
        component="h1"
        sx={{
          fontFamily: '"Playfair Display", Georgia, serif',
          fontWeight: 400,
          color: CHAT_CHA.text,
          mb: { xs: 1.25, md: 1.5 },
          fontSize: { xs: '1.5rem', md: '1.75rem' },
          lineHeight: 1.2,
        }}
      >
        Chat with Vendors
      </Typography>

      <Paper
        elevation={0}
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 3,
          border: `1px solid ${CHAT_CHA.border}`,
          bgcolor: CHAT_CHA.shellBg,
          overflow: 'hidden',
          boxShadow: '0 4px 24px rgba(46, 38, 28, 0.06)',
        }}
      >
        <ChatComponent
          currentUserPhone={user.phoneNumber}
          userType="CLIENT"
          shell="chaavi"
        />
      </Paper>
    </Box>
  );
};

export default ClientChat;
